export default {
  d: "M50.3,0v472.6l372.1-236.3L50.3,0z",
  viewBox: "0 0 472.6 472.6"
}
